import AdminApplications from "../../components/Admin/AdminApplications";
import DashboardLayout from "../../components/Layout/DashboardLayout";
import { applicationStatusMap } from "../../config/applicationStatusConfig";

const PaymentDoneApplicaitons = () => {
  return (
    <DashboardLayout pageTitle="Application" mainClass="p-6">
      <AdminApplications
        title="Approved Applications"
        status={[applicationStatusMap?.paymentDone.value]}
        stage={[]}
      />
    </DashboardLayout>
  );
};

export default PaymentDoneApplicaitons;
